import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import ModuleReader from "@/pages/ModuleReader";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminStaff from "@/pages/AdminStaff";
import AdminModules from "@/pages/AdminModules";
import AdminEmployee from "@/pages/AdminEmployee";
import { Tent } from "lucide-react";

function Splash() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background">
      <span className="flex h-14 w-14 animate-pulse items-center justify-center rounded-2xl bg-primary text-primary-foreground">
        <Tent className="h-7 w-7" />
      </span>
      <p className="text-sm text-muted-foreground">Loading…</p>
    </div>
  );
}

function Protected({ children, admin }) {
  const { user, checked } = useAuth();
  if (!checked || user === null) return <Splash />;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  if (!admin && user.role === "admin") return <Navigate to="/admin" replace />;
  return <Layout>{children}</Layout>;
}

function LoginGate() {
  const { user, checked } = useAuth();
  if (!checked || user === null) return <Splash />;
  if (user) return <Navigate to={user.role === "admin" ? "/admin" : "/"} replace />;
  return <Login />;
}

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginGate />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/module/:id" element={<Protected><ModuleReader /></Protected>} />
          <Route path="/admin" element={<Protected admin><AdminDashboard /></Protected>} />
          <Route path="/admin/staff" element={<Protected admin><AdminStaff /></Protected>} />
          <Route path="/admin/modules" element={<Protected admin><AdminModules /></Protected>} />
          <Route path="/admin/employee/:id" element={<Protected admin><AdminEmployee /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
